import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PACaricaFatturaSummaryComponent } from './pa-carica-fattura-summary';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.pa-carica-fattura-summary', {
            url: '/pa-carica-fattura-summary',
            ncyBreadcrumb: {
                label: 'Carica Fattura Riepilogo',
                parent: 'home.fatturazione-pa'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Carica fattura Riepilogo'
            },
            'views': {
                'homeContent': {
                    template: '<pa-carica-fattura-summary flex="100"></pa-carica-fattura-summary>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PACaricaFatturaSummaryModule: string = ng
    .module('pa-carica-fattura-summary', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('paCaricaFatturaSummary', PACaricaFatturaSummaryComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-carica-fattura-summary/pa-carica-fattura-summary.module.ts